import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import ExperienceSection from "./components/ExperienceSection";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import HackathonSection from './components/HackathonSection';
import Education from './components/education';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { HelmetProvider } from "react-helmet-async";
import SEO from './components/SEO';
import { Analytics } from "@vercel/analytics/react"


function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Analytics />
        <SEO />
        <NavBar />
        <Banner />
        <Skills />
        <Projects />
        <section className="experience-wrapper" id="experience">
          <div className="container">
            <h2 className="experience-title">Experience</h2>
            <p className="experience-subtitle">
              Roles and internships where I shipped products and learned from real teams.
            </p>
            <ExperienceSection />
          </div>
        </section>
        <HackathonSection />
        <Education />
        <Contact />
        <Footer />
        <SpeedInsights />
      </div>
    </HelmetProvider>
  );
}

export default App;
